module.exports = __webpack_public_path__ + "media/assets/icons/calendar-1abf0e0e03d655d927245f8cb647e616.svg";